"use client";
import {
  Box,
  Divider,
  Heading,
  SimpleGrid,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  VStack,
  Text,
} from "@chakra-ui/react";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import PricingFooter from "@/components/pricingFooter";
import {RAM_CONSTANTS} from "./constants";

// Desktop table component
const RamPricingTable = ({option}) => {
  return (
    <Box borderWidth={"1px"} borderRadius="lg" p={4} bg="white" boxShadow={"lg"}>
      <Heading size="md" mb={6}>
        {option.title}
      </Heading>
      {option.desc.map((line, idx) => (
        <Text key={idx} mb={2} color="text.100">
          {line}
        </Text>
      ))}
      <TableContainer mt={6}>
        <Table variant="striped" border="2px solid rgb(237,242,247)" width="100%">
          <Thead>
            <Tr>
              <Th rowSpan={2} textAlign="center">
                Cloudlets
              </Th>
              <Th colSpan={2} textAlign={"center"} border="2px solid #EDF2F7">
                Cost per Reserved Cloudlet
              </Th>
            </Tr>
            <Tr>
              <Th textAlign="center" border="2px solid #EDF2F7">
                Hourly Price
              </Th>
              <Th textAlign="center" border="2px solid #EDF2F7">
                Discount
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {option.data.map((row, idx) => (
              <Tr key={idx}>
                <Td textAlign="center">{row.cloudlet}</Td>
                <Td textAlign="center" fontWeight="bold" color="blue.600">
                  {row.pricing.hourly}
                </Td>
                <Td textAlign="center" color="green.500">
                  {row.pricing.discount}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

// Mobile card view
const RamPricingMobileCard = ({option}) => {
  return (
    <VStack borderWidth="1px" borderRadius="lg" p={4} bg="white" spacing={4}>
      <Heading size="md">{option.title}</Heading>
      {option.desc.map((line, idx) => (
        <Text key={idx} fontSize="sm" color="gray.600">
          {line}
        </Text>
      ))}
      <SimpleGrid columns={2} spacing={4} w="full">
        {option.data.map((row, idx) => (
          <Stack key={idx} spacing={2} borderWidth="1px" borderRadius="md" p={3} w="full">
            <Box>
              <Text as="span" fontSize="sm" color="text.100">
                Cloudlets : {""}
              </Text>
              <Text as="span" fontWeight="medium" fontSize="md">
                {row.cloudlet}
              </Text>
            </Box>
            <Box>
              <Text as="span" fontSize="sm" color="text.100">
                Price : {""}
              </Text>
              <Text as="span" fontWeight="medium" fontSize="md">
                {row.pricing.hourly} / hour
              </Text>
            </Box>
            <Box>
              <Text as="span" fontSize="sm" color="text.100">
                Discount : {""}
              </Text>
              <Text as="span" fontWeight="medium" fontSize="md">
                {row.pricing.discount}
              </Text>
            </Box>
          </Stack>
        ))}
      </SimpleGrid>
    </VStack>
  );
};

// Main View Component
const RamPricingTables = () => {
  const {heading, options, footer} = RAM_CONSTANTS;
  const HeadingVariant = useSectionHeadingVariant();
  return (
    <Box id="paas">
      <Heading variant={HeadingVariant} textAlign="center" mb={8}>
        {heading}
      </Heading>

      {/* Desktop View */}
      <Box display={{base: "none", md: "block"}}>
        <SimpleGrid columns={2} spacing={8}>
          {options.map((option, idx) => (
            <RamPricingTable key={idx} option={option} />
          ))}
        </SimpleGrid>
      </Box>

      {/* Mobile View */}
      <Box display={{base: "block", md: "none"}}>
        <Stack spacing={6}>
          {options.map((option, idx) => (
            <RamPricingMobileCard key={idx} option={option} />
          ))}
        </Stack>
      </Box>
      <PricingFooter {...footer} />
      <Divider borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default RamPricingTables;
